import { Component } from "@angular/core";
import { LoaderService } from "@core/services/loader/loader.service";
import { CommonModule } from "@angular/common";
@Component({
  selector: "app-loader",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
